import { httpCreate } from './http';

const http = httpCreate('/shop/api/surveyAnswer/');

export const surveyAnswer = {
	listTh(surveyId) {
		return http.get(`getTitle/${surveyId}`);
	},
	listTr(activityId, surveyId, params) {
		return http.get(`${activityId}/${surveyId}`, { params: params });
	},
	listTrGather(gatherId, surveyId, params) {
		return http.get(`${gatherId}/gather/${surveyId}`, { params: params });
	},
	getTitle(surveyId) {
		return http.get(`/getTitle/${surveyId}`);
	},
};
